module.exports = __webpack_public_path__ + "img/carregando.556a055e.gif";